/**
 * Created by mukund on 2/24/17.
 *
 * This file contains the controller for the LMS Assignments Tool module
 */

angular.module('mediacloudApp')
    .controller('LMSAssignmentsController', function($scope, $state, Principal, Tenant, UploadErrors, BatchService, BaseFileService, CollectionService, AssetService, $http){

        Principal.identity().then(function(account) {
            $scope.account = account;
            $scope.userName = account.login;
            if($scope.account.firstName || $scope.account.lastName){
                $scope.userFullName = $scope.account.firstName ? $scope.account.firstName : "";
                $scope.userFullName += $scope.account.lastName ? " " + $scope.account.lastName : $scope.account.lastName;
            } else {
                $scope.userFullName = $scope.userName;
            }
            $scope.errors = [];
            $scope.batch = {};
            $scope.file = {};
            $scope.file.readyForUpload = false;
            $scope.file.uploadStarted = false;
            if ($state.params.collectionId) {

                var assignments = new CollectionService.GetStudentAssignmentCollection({cid: $state.params.collectionId});
                assignments.$save(function(response){
                    $scope.destination = {title: "Assignments", cid: response.cid, childCollections:[]};

                    Tenant.info().then(function(data) {

                        $scope.tenantId = data.id;
                        $scope.uploadUrl = data.uploadUrl;
                        $scope.contributor = data.showUserFullName ? $scope.userFullName : $scope.userName;

                        // Upload the batch when the user clicks on the upload batch button
                        $scope.uploadBatch = function(){
                            var uploadParams = [{userId: $scope.userName}, {tenantId: $scope.tenantId}];
                            if($scope.file.needsTranscoding) {
                                uploadParams.push({generateThumbnail: true});
                            } else {
                                uploadParams.push({skipProcessing: true});
                            }
                            var addBatchRequest = new BatchService.CreateBatch();
                            addBatchRequest.$save(function(batch){
                                angular.merge($scope.batch, batch);
                                BaseFileService.GetUploadToken.get(function(data){
                                    uploadParams.push({jwt: data.token});
                                    var fileItem = $scope.batch.uploader.queue[0];
                                    fileItem.formData = uploadParams;
                                    fileItem.url = $scope.uploadUrl;
                                    fileItem.upload();
                                    $scope.file.uploadStarted = true;
                                }, function(){
                                    $scope.errors.push({id: 'ae' + Date.now(), msg: UploadErrors.GET_UPLOAD_TOKEN.formatMessage({name: $scope.file.name})});
                                    // Cancel & Remove the file from the file list since this is a fatal error
                                    $scope.cancelFile();
                                });
                            }, function(){
                                $scope.errors.push({id: 'ae' + Date.now(), code: UploadErrors.CREATE_BATCH});
                            });
                        };
                    });

                    $scope.clickUploader = function () {
                        $('#single-uploader-input').click();
                    };

                    // Cancel Operations
                    $scope.cancelFile = function() {
                        var fileId = $scope.file.fileId ? $scope.file.fileId : $scope.file.mediacloudFileId;
                        if(fileId){
                            // Cancel the basefile entry first, if it already exists before updating the UI
                            BaseFileService.CancelBaseFile.erase({id: fileId}, function(){
                                $scope.closeUploader();
                            }, function(){
                                $scope.errors.push({id: 'ae' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                            });
                        } else {
                            $scope.closeUploader();
                        }
                    };

                    var updateFileMetadata = $scope.updateFileMetadata = function(){
                        var fileId = $scope.file.fileId ? $scope.file.fileId : $scope.file.mediacloudFileId;
                        if(fileId){
                            var baseFileResource = new BaseFileService.AddMetadata({
                                id: fileId,
                                title: $scope.file.metadata.title,
                                contributor: $scope.file.metadata.contributor,
                                description: $scope.file.metadata.description,
                                isStudentUpload: true
                            });
                            baseFileResource.$save(function(){
                                var notify = $scope.file.sendNotificationToUser ? $scope.file.sendNotificationToUser : false;
                                var baseFileNotificationResource = new BaseFileService.NotifyUser({id: fileId, notify: notify});
                                baseFileNotificationResource.$save(function(){
                                }, function(){
                                    $scope.errors.push({id: 'ae' + Date.now(), msg: UploadErrors.SEND_USER_NOTIFICATION});
                                });
                            }, function(){
                                $scope.errors.push({id: 'ae' + Date.now(), msg: UploadErrors.UPDATE_FILE_METADATA});
                            });
                        }
                    };

                    $scope.addMedia = function(){
                        var files = [];
                        if($scope.file && $scope.file.uploadComplete) {
                            files.push({id: $scope.file.fileId, name: $scope.file.metadata.title});
                        }
                        if(files.length > 0){
                            AssetService.AddMedia.embed(files,function(data){
                                console.log("Added Media Files");
                                if(data.lmsType == 'moodle' && data.contentItemReturnUrl === ""){
                                    jQuery.ajax({
                                        url: "api/lms/js",
                                        dataType: 'script',
                                        headers: {'x-auth-token': $http.defaults.headers.common['x-auth-token'] },
                                        success: function(data){
                                            console.log("Remote LMS JS Loaded.");
                                            loadLMSJS(files[0].id);
                                        },
                                        error: function(jqXHR, textStatus, errorThrown) {
                                            alert("Remote LMS JS Load failed!!")
                                        }
                                    });
                                }else{
                                    $http({
                                        method: 'GET',
                                        url: 'api/lms/embed'
                                    }).then(function successCallback(response) {
                                        //Check for content item message
                                        // Make the form post
                                        if(response.data.params){
                                            'use strict';
                                            var form;
                                            form = $('<form />', {
                                                action: response.data.redirectUrl,
                                                method: "POST",
                                                style: 'display: none;'
                                            });
                                            if (typeof response.data.params !== 'undefined' && response.data.params !== null) {
                                                $.each(response.data.params, function (name, value) {
                                                    $('<input />', {
                                                        type: 'hidden',
                                                        name: name,
                                                        value: value
                                                    }).appendTo(form);
                                                });
                                            }
                                            form.appendTo('body').submit();
                                        }else{
                                            window.location=response.data.redirectUrl;
                                        }
                                    }, function errorCallback(response) {
                                        console.log(response);
                                    });
                                }

                            }, function(){
                                $scope.errors.push({id: 'ae' + Date.now(), msg: UploadErrors.EMBED});
                            });
                        }
                    };

                    $scope.closeUploader = function(reload){
                        $scope.batch.uploader.cancelAll();
                        $scope.batch.uploader.clearQueue();
                        if(reload) {
                            $state.reload();
                        }
                    };


                });
            }
        });
    });
